/**
 * enginePreProcessJson_Merge_Constants.ts - Type prefix constants for EnginePreProcessJson
 * Pure ES module - works in both Node.js and browser via bundler
 *
 * Uses new HtmlJson format with type prefixes:
 * s=Html, k=JsonKey, K=JsonKeySkip, p=Placeholder, P=PlaceholderSkip,
 * h=Slotholder, H=SlotholderSkip, a=ArrayBlock, A=ArrayBlockSkip, x=SlotHtml, i=Slot, c=Conditional
 */

// Type prefix constants for new format
export const TYPE_HTML = 's';
export const TYPE_JSONKEY = 'k';
export const TYPE_JSONKEY_SKIP = 'K';
export const TYPE_PLACEHOLDER = 'p';
export const TYPE_PLACEHOLDER_SKIP = 'P';
export const TYPE_SLOTHOLDER = 'h';
export const TYPE_SLOTHOLDER_SKIP = 'H';
export const TYPE_ARRAYBLOCK = 'a';
export const TYPE_ARRAYBLOCK_SKIP = 'A';
export const TYPE_SLOTHTML = 'x';
export const TYPE_SLOT = 'i';
export const TYPE_CONDITIONAL = 'c';
export const META_KEY = '_meta';

/**
 * Convert milliseconds to nanoseconds
 */
export function msToNanos(ms: number): number {
    return Math.round(ms * 1_000_000);
}

/**
 * Checks if this is a type-prefixed key (new format: type char + digit, e.g., "k2_Title", "s1")
 * vs a regular key like "PLACEHOLDER", "MainBlock", etc.
 */
export function isTypePrefixedKey(key: string): boolean {
    return key.length >= 2 && /\d/.test(key[1]);
}

import { JsonObject } from '../../../../Assembler/dist/app/json/jsonValue.js';

/**
 * Gets the first HTML value from an HtmlJson object (for skip/missing templates)
 */
export function getFirstHtmlValue(htmlJson: JsonObject): string {
    if (!htmlJson) return '';
    for (const k of htmlJson.keys()) {
        if (k === META_KEY) continue;
        const keyType = isTypePrefixedKey(k) && k.length > 0 ? k[0] : '\0';
        if (keyType === TYPE_HTML) {
            return htmlJson.get(k).asString() ?? '';
        }
    }
    // Fallback for old format
    const legacyVal = htmlJson.get('001_Html');
    if (!legacyVal.isNull) return legacyVal.asString() ?? '';
    return '';
}
